let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lDcy8")).then(() => parcelRequire('2JrrX'));